import vars from '../theme/vars';

const SignupStyle = {
  SignupLeftSide: {
    display: 'flex',
    width: '35%',
    flexDirection: 'column',
    backgroundColor: '#010101',
    color: 'white',
    padding: '4% 6%',
    justifyContent: 'space-around',
  },

  // scrollViewStyle: {
  //   flex: 1,
  //   justifyContent: 'center',
  //   padding: isMobile && 20,
  //   alignItems: !isMobile && 'center',
  //   overflow: 'hidden',
  // },

  SignupBoxStyle: {
    flex: 1,
    overflow: 'hidden',
    borderColor: vars.colors.white,
  },

  SignupText: {
    // marginBottom: !isMobile ? -32 : -20,
    zIndex: 1,
    fontFamily: 'Mulish-Bold',
    // fontSize: !isMobile ? 68 : 44,
    color: '#010101',
    fontWeight: 700,
    fontSize: 20,
    marginBottom: 35,
  },
  SignuperrorStyle: {
    ...vars.headings.h14,
    color: vars.colors.error,
    textAlign: 'center',
  },
  createAccountButtonProperties: {
    cursor: 'pointer',
    color: '#FAFAFA',
    width: 200,
    padding: 10,
    borderRadius: 100,
    backgroundColor: '#444444',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: 14,
    fontWeight: 700,
    fontFamily: 'Montserrat',
  },
  formFieldProperties: {
    width: '100%',
    backgroundColor: '#FAFAFA',
    border: '1px solid #DFDFFA',
    borderRadius: '10px',
    marginRight: '10px',
    // width: '25vw',
  },
  boxToHoldAllFields: {
    display: 'flex',
    gap: 7,
    // border: '1px solid red',
    //width: 'inherit',
  },
  boxToHoldRowFields: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    margin: '1vh 0vw',
    flexWrap: 'wrap',
  },

  boxToHoldSingleField: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    margin: '1vh 0vw',
    flexWrap: 'wrap',
  },
  boxToHoldIndividualField: {
    width: '45%',
  },
  boxToHoldIndividualFieldAdd: {
    width: '94%',
  },
  rightSide: {
    width: '65%',
    height: '90%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  boxToHoldSignupTitle: {
    display: 'flex',
    justifyContent: 'center',
    // fontSize: '20px',
    flexDirection: 'row',
    marginBottom: '2vh',
    color: '#010101',
    fontFamily: 'Montserrat',
    fontSize: 20,
    fontWeight: 700,
    // fontFamily: 'Roboto',
  },
  boxToHoldCheckbox: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    paddingLeft: '1vw',
    paddingRight: '1vw',
    margin: '2vh 0vw',
    fontFamily: 'Montserrat',
  },
  checkboxTextProperties: {
    marginLeft: '0.5vw',
    fontSize: '16px',
  },
  boxToHoldCreateAccountButton: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  alreadyBox: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '16px',
    margin: '2vh 0vw',
    fontFamily: 'Montserrat',
  },
  alreadyLoginButtonProperties: {
    cursor: 'pointer',
    backgroundColor: 'transparent',
    // textDecoration: 'underline',
    color: 'rgb(96, 91, 255)',
  },
  boxToShowCheckError: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '20px',
    color: 'red',
  },
  boxToShowPasswordError: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '16px',
    color: 'red',
  },
  boxToShowPhoneNumberError: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '20px',
    color: 'red',
  },
  termsOfUseButtonProperties: {
    cursor: 'pointer',
    color: 'rgb(96, 91, 255)',
    backgroundColor: 'transparent',
    display: 'inline',
    textDecoration: 'underline',
  },

  privacyPolicyButtonProperties: {
    cursor: 'pointer',
    color: 'rgb(96, 91, 255)',
    backgroundColor: 'transparent',
    display: 'inline',
    textDecoration: 'underline',
  },
};

export default SignupStyle;
